import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Company() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Modern%20industrial%20company%20building%20exterior%20with%20professional%20architecture%2C%20clean%20design%2C%20and%20corporate%20identity%20signage%20representing%20metal%20fabrication%20business%20in%20Fukuoka%20Japan%20with%20blue%20sky%20background&width=1920&height=600&seq=company-building&orientation=landscape')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            会社概要
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            製造業のすべてのお困りごとを解決するために設立<br />
            45年以上の経営実績を持つ代表が率いる会社です
          </p>
        </div>
      </section>

      {/* Company Mission */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">設立の目的</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
            <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-medium">
              メタルリンク株式会社は、<strong className="text-amber-600">製造業の経営・運営・製造に関わるすべてのお困りごとを解決する</strong>ために設立されました
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white rounded-2xl shadow-2xl p-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className="ri-line-chart-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3 text-amber-300">経営</h3>
                <p className="text-gray-300">経営戦略から財務管理まで</p>
              </div>
              <div>
                <div className="w-20 h-20 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className="ri-settings-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3 text-gray-300">運営</h3>
                <p className="text-gray-300">工場運営から人材管理まで</p>
              </div>
              <div>
                <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className="ri-hammer-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3 text-amber-300">製造</h3>
                <p className="text-gray-300">金属加工から品質管理まで</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CEO Experience */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">代表の経歴</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://static.readdy.ai/image/33e5933f6fefe5b5ffe80f6f6608a7a2/801b474be2f3a1639eeada1d8933cb72.jpeg"
                alt="代表取締役 大森孝人"
                className="rounded-lg shadow-2xl object-cover w-full h-96 border-4 border-amber-400/30"
              />
            </div>
            <div>
              <div className="inline-block bg-gradient-to-r from-amber-400 to-yellow-500 text-gray-900 px-6 py-2 rounded-full text-sm font-bold mb-6">
                製造業に携わること45年
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                鉄工所から超精密モールド金型まで<br />幅広い経験を持つ代表
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  代表取締役の大森孝人は、<strong className="text-amber-600">製造業に携わること45年</strong>。メタルリンク株式会社を設立する前に、45年以上にわたり精密金型パーツ会社を経営してきました。
                </p>
                <p>
                  <strong className="text-amber-600">鉄工所から超精密モールド金型及びプレス金型まで</strong>、幅広い分野で豊富な経験を積み重ねてきました。この多様な経験により、製造業のあらゆる工程と課題を深く理解しています。
                </p>
                <p>
                  長年の経営経験を通じて、製造業が直面する様々な課題を深く理解し、技術力だけでなく、経営・運営面でも豊富な知見を蓄積してきました。
                </p>
                <p>
                  この経験を活かし、製造業のあらゆるお困りごとを解決するために、メタルリンク株式会社を設立いたしました。
                </p>
              </div>

              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-6 border-2 border-amber-400">
                  <div className="text-4xl font-bold text-amber-600 mb-2">45</div>
                  <div className="text-gray-700 font-semibold">製造業に携わる年数</div>
                </div>
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 border-2 border-gray-400">
                  <div className="text-2xl font-bold text-gray-700 mb-2">幅広い</div>
                  <div className="text-gray-700 font-semibold">鉄工所〜超精密金型</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Information */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">会社情報</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="space-y-6">
              <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-amber-500">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">会社名</h3>
                <p className="text-gray-600">メタルリンク株式会社</p>
                <p className="text-gray-500 text-sm">METAL LINK Co,Ltd.</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-amber-500">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">代表取締役</h3>
                <p className="text-gray-600">大森 孝人</p>
                <p className="text-gray-500 text-sm">Oomori Takato</p>
                <p className="text-amber-600 text-sm font-semibold mt-2">精密金型パーツ会社 45年以上の経営実績</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-gray-500">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">所在地</h3>
                <p className="text-gray-600">〒822-0002</p>
                <p className="text-gray-600">福岡県直方市上頓野4711-7</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-gray-500">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">連絡先</h3>
                <p className="text-gray-600">
                  <i className="ri-mail-line mr-2"></i>
                  <a href="mailto:t_oomori@metal-link.jp" className="hover:text-amber-600 transition-colors cursor-pointer">
                    t_oomori@metal-link.jp
                  </a>
                </p>
                <p className="text-gray-600">
                  <i className="ri-phone-line mr-2"></i>
                  <a href="tel:0949528650" className="hover:text-amber-600 transition-colors cursor-pointer">
                    0949-52-8650
                  </a>
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-amber-500">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">事業内容</h3>
                <p className="text-gray-600 font-semibold mb-2">製造業の経営・運営・製造に関わるすべてのお困りごと解決</p>
                <ul className="text-gray-600 space-y-1 text-sm">
                  <li>• 精密金属加工業</li>
                  <li>• 製造業経営支援</li>
                  <li>• 各種専門サービスの紹介業務</li>
                </ul>
              </div>
            </div>

            <div>
              <img 
                src="https://static.readdy.ai/image/33e5933f6fefe5b5ffe80f6f6608a7a2/740d9f58669de578f2d28933d13397f8.jpeg"
                alt="代表取締役 大森孝人"
                className="rounded-lg shadow-2xl object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CEO Message */}
      <section className="py-20 bg-gradient-to-br from-amber-50 to-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">代表挨拶</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              製造業のすべてのお困りごと解決を使命として
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="w-32 h-32 bg-gray-200 rounded-full flex-shrink-0 mx-auto md:mx-0">
                <img 
                  src="https://static.readdy.ai/image/33e5933f6fefe5b5ffe80f6f6608a7a2/087ffa8ef5454c001ee98c4b41828a1a.jpeg"
                  alt="代表取締役 大森孝人"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">代表取締役　大森 孝人</h3>
                <div className="text-gray-600 leading-relaxed space-y-4">
                  <p>
                    メタルリンク株式会社のホームページをご覧いただき、誠にありがとうございます。
                  </p>
                  <p>
                    私は45年以上にわたり精密金型パーツ会社を経営してまいりました。その長年の経験の中で、製造業が直面する課題は、技術面だけでなく、経営・運営・人材・財務など、多岐にわたることを痛感してきました。
                  </p>
                  <p>
                    メタルリンク株式会社は、<strong className="text-amber-600">製造業の経営・運営・製造に関わるすべてのお困りごとを解決する</strong>という明確な目的のもとに設立いたしました。
                  </p>
                  <p>
                    精密金属加工の技術力はもちろん、45年以上の経営経験で培った知見、そして信頼できる専門家ネットワークを活かし、お客様のあらゆる課題に対してワンストップでソリューションを提供いたします。
                  </p>
                  <p>
                    製造・運営・経営のどのような課題でも、まずはお気軽にご相談ください。お客様の「お困りごと」を解決することが、私たちの使命です。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Philosophy */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">経営理念・強み</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              お客様第一の姿勢で、継続的な成長を目指します
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">お客様第一</h3>
              <p className="text-gray-600">
                お客様の課題解決を最優先に考え、常にお客様の立場に立ったサービスを提供いたします。
              </p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-green-50 to-green-100 rounded-lg">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">技術革新</h3>
              <p className="text-gray-600">
                常に最新の技術動向を把握し、お客様により良いソリューションを提供できるよう努めています。
              </p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">地域貢献</h3>
              <p className="text-gray-600">
                地域の製造業の発展に貢献し、地域経済の活性化に寄与することを目指しています。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">事業領域</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              幅広い技術領域でお客様をサポート
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">金属加工事業</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">鉄加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">非鉄加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">鋳物加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">表面処理</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">木型製作</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">旋盤加工</span>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">MC加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">研削加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">板金加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">製缶加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">溶接加工</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-700 text-sm">砥石加工</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">紹介事業</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-brush-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">工場塗装</h4>
                    <p className="text-gray-600 text-sm">耐熱・スレート強化塗装</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-team-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">人材紹介</h4>
                    <p className="text-gray-600 text-sm">専門技術者のご紹介</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-search-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">興信所</h4>
                    <p className="text-gray-600 text-sm">信用調査・身元調査</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-calculator-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">税理士</h4>
                    <p className="text-gray-600 text-sm">税務・会計のご相談</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-file-text-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">社会労務士</h4>
                    <p className="text-gray-600 text-sm">労務管理・社会保険</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Access Information */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">アクセス</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              福岡県直方市に拠点を構え、地域のお客様にサービスを提供しています
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-gray-50 rounded-lg p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">所在地</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-map-pin-line text-blue-600"></i>
                    </div>
                    <div>
                      <p className="text-gray-900 font-semibold">メタルリンク株式会社</p>
                      <p className="text-gray-600">〒822-0002</p>
                      <p className="text-gray-600">福岡県直方市上頓野4711-7</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-mail-line text-blue-600"></i>
                    </div>
                    <div>
                      <a href="mailto:t_oomori@metal-link.jp" className="text-blue-600 hover:text-blue-700 transition-colors cursor-pointer">
                        t_oomori@metal-link.jp
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-phone-line text-blue-600"></i>
                    </div>
                    <div>
                      <a href="tel:0949528650" className="text-blue-600 hover:text-blue-700 transition-colors cursor-pointer">
                        0949-52-8650
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="bg-gray-200 rounded-lg h-96 flex items-center justify-center">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7888.367601693025!2d130.7556373723213!3d33.76970865567036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3543cfd64eaa0685%3A0xac09eac16f543a46!2z44CSODIyLTAwMDMg56aP5bKh55yM55u05pa55biC5LiK6aCT6YeO77yU77yX77yR77yR4oiS77yX!5e0!3m2!1sja!2sjp!4v1766376284845!5m2!1sja!2sjp"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '0.5rem' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="メタルリンク株式会社の所在地"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            お困りごとはございませんか？
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            金属加工から専門サービスまで、どのようなことでもお気軽にご相談ください。<br />
            お客様の課題解決をサポートいたします。
          </p>
          <a 
            href="/contact" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap inline-block"
          >
            お問い合わせはこちら
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}